<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input mt-2"
            :options="pricetypelist" v-model="price_type" :reduce="name => name.id" label="name"> <template
              #selected-option="{ name }">
              <b>{{ $t(name) }}</b>
            </template>
            <template #option="{ name }">
              <b>{{ $t(name) }}</b>
            </template>
          </v-select>
      </div>
          <button style="float: right;" type="button" class="btn btn-primary" @click='Print()'>
            <b-icon icon="printer"></b-icon>
          </button>
          <button style="float: right;" type="button" class="btn btn-success" @click='Clear()'>
            {{$t('Тозалаш')}}
          </button>
          <button style="float: right;" class="addrow btn btn-primary" type="button" @click="Addtable()">
            <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
          </button>
    </div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="column1">№</th>
          <th class="column3">Штрих</th>
          <th>Товар</th>
          <th class="column2">{{$t('Қолдиқ')}}</th>
          <th class="column2">{{$t('Нарх')}} <input type="checkbox" v-model="price"></th>
          <th class="column2">{{$t('Cони')}}
          </th>
          <th class="column1"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{index+1}}</td>
          <td class="column3">{{item.shtrix_kod}}</td>
          <td>
            <v-select style="width: 100%;" :disabled="changedisabled" v-if="productlist != null"
              :filter-by="$store.state.myFilter" :clearable="false" class="form-control-sm required"
              @search="query => (search = query)" :options="paginated" menu-props="auto" v-model="item.product_id"
              :reduce="extra_name => extra_name.id" label="extra_name" @input="Productchange(index)">
              <template #list-footer>
                <li style="text-align: center;font-weight:bold;">
                  f4 {{ $t("умумий рўйхат") }}
                </li>
              </template>
              <template #selected-option-container="{option}">
                <div class="vs__selected">
                  <span v-if="typeof option.extra_name === 'number'">{{
                    Label(option.extra_name)
                    }}</span><span v-else>{{ option.extra_name }}</span>
                </div>
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"></span>
                <button :disabled="changedisabled" type="button" class="modallist" @click="Selectproduct(index)">
                <b-icon icon="three-dots"></b-icon>
              </button>
              </template>
              <template #selected-option="{ extra_name }">
                <div style="position: absolute">
                  {{ extra_name }}
                </div>
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                  <!-- <button type="button" class="pluss" @click="CreateProduct(index, search)">
                  +</button><b>Insert</b> -->
                </template>
                <em style="opacity: 0.5" v-else>{{
                  $t("Маьлумот йўқ")
                  }}</em>
              </template>
              <template #search="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                </template>
              </template>
            </v-select>
          </td>
          <td class="column2">{{item.current_balance}}</td>
          <td class="column2">
            {{ (price_type === 'chakana') ?  $options.filters.numFormat(item.chakana_price) :  $options.filters.numFormat(item.optom_price) }}
          </td>
          <td class="column2">
            <input type="number" class="table-input" @input="item.count=parseInt(item.count)" v-model="item.count">
          </td>
          <td class="column1">
            <a href="javascript:void(0)" class="circul trash" @click="Trashitem(index)">
              <b-icon icon="trash"></b-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mybody" style="display: none;">
      <span v-for="(item, index) in list" :key="index">
        <div v-if="item.shtrix_kod!=''" v-for="n in item.count">
          <div class="page" v-if="price!=true">
            <div class="text-center" v-if="printer.file_name!=null" ><img style="width: 70%;height: 10vh;"
          :src="axios.defaults.baseURL+'/api/v1/uploads/'+printer.file_name"></div>
            <center style="height: 15vh;">{{item.product.extra_name}}</center>
            <barcode width="3" height="110px" :value="item.shtrix_kod"></barcode>
            <center v-if="price==true">
              <!-- {{item.chakana_price|numFormat}}  -->
            {{ (price_type === 'chakana') ?  $options.filters.numFormat(item.chakana_price) :  $options.filters.numFormat(item.optom_price) }}
              </center>
          </div>
          <div class="page price" v-else>
            <center style="height: 28vh;">{{item.product.extra_name}}</center>
            <div style="height: 15vh!important;">
              <div style="text-align: center;width: 150%!important;">
                <div class="pricebarcode">
                  <b class="pricetext">
                    <!-- {{item.chakana_price|numFormat0}} -->
            {{ (price_type === 'chakana') ?  $options.filters.numFormat(item.chakana_price) :  $options.filters.numFormat(item.optom_price) }}
                  </b>
                  <div style="width: 80px !important;display: block;">
                    <!-- <p>{{item.chakana_price|numFormat0}}</p> -->
                    <!-- <hr class="hr"> -->
                    <p>cўм</p>
                  </div>
                </div>
              </div>
            </div>
            <barcode width="2" height="48px" :value="item.shtrix_kod"></barcode>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>
<style>
  .vue-barcode-element {
    width: 125% !important;
    height: 24vh;
  }

  .pricebarcode p {
    text-align: center;
  }

  .pricebarcode {
    display: inline-flex;
    /* width: 150%!important; */
  }

  .price .vue-barcode-element {
    width: 150% !important;
    height: 28vh;
  }

  .price p {
    font-size: 50pt;
  }

  .mybody {
    /* margin: -40% 0!important; */
  }

  .page center {
    /* zoom: 1; */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1;
    font-weight: bold;
    width: 145% !important;
    /* height: 30vh; */
    font-size: 100pt !important;
  }

  .pricetext {
    text-align: center !important;
    /* width: 75%; */
    line-height: 1;
    font-weight: 100;
    font-size: 180pt !important;
  }

  .page {
    page-break-after: always;
    page-break-inside: avoid;
    padding: 0 !important;
    /* width: 145%!important; */
    /* width: 1000px; */
    transform: rotate(90deg);
  }

  .page.price>center {
    font-size: 100pt !important;
  }

  .vue-barcode-element text {
    text-align: center;
    font-size: 20pt !important;
  }
</style>
<script>
  import { print } from "../../../components/mixins/print.js";
  import $ from "jquery";
  import VueBarcode from 'vue-barcode';
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  export default {
    name: "Print",
    mixins: [print],
    components: { 'barcode': VueBarcode },
    data() {
      return {
        printer:{},
        pricetypelist: [
          { id: "optom", name: "Оптом" },
          { id: "chakana", name: "Чакана" }
        ],
        price_type: "chakana",
        product_id: 0,
        productlist: [],
        price: true,
        list: [],
        mysklad: [],
        rotateType: 0,
        options: {
          offsetX: 0,
          offsetY: 0,
          imageWidth: 300
        },
        qarz: 0
      };
    },
    created: function () {
      this.Data();
      this.GetPrinterName();
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.list[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          if (this.$store.state.selected_index != null) {
            console.log(this.$store.state.selected_index);
            this.Productchange(this.$store.state.selected_index);
          }
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      })
    },
    mounted: function () {
      this.Productlist();
      this.Addtable();
    },
    methods: {
      GetPrinterName() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
        }).then(function (response) {
          if (response.data.data != null) {
            self.printer = JSON.parse(response.data.data);
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "noopener,noreferrer,width=1200,height=1000");
        // window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.list.splice(index, 1);
        }
      },
      Addtable(type = 'default') {
        this.list.push({
          product_id: 0,
          current_balance: 0,
          count: 1,
          debit_price: 0,
          debit_summa: 0,
          kontragent_price: 0,
          kontragent_summa: 0,
          chakana_percent: 0,
          optom_percent: 0,
          chakana_price: 0,
          chakana_price: 0,
          optom_price: 0,
          optom_price: 0,
          chakana_summa: 0,
          optom_summa: 0,
          shtrix_kod: "",
          pack_count: 0,
          product: null,
          pack_price: 0,
          pack_norma: 0
        });
        if (type == 'default') {
          this.Tablefocus();
        }
      },
      Print() {
        var head = $(".mybody").html();
        if (head == undefined) {
          head = "";
        }
        window.document.body.innerHTML = head;
        window.print();
        window.location.reload();
      },
      Clear() {
        let self = this;
        self.list.forEach(function (key, value) {
          key.count = 0;
        });
      },
      Productchange(index) {
        if (this.changedisabled == false) {
          let self = this;
          var item = self.list[index];
          item.optom_price = 0;
          item.chakana_price = 0;
          axios({
            method: "post",
            url: "api/v1/product/price-balance",
            data: { product_id: item.product_id, sklad_id: parseInt(localStorage.getItem("sklad_id")) }
          }).then(function (response) {
            item.current_balance = response.data.balance;
            if (response.data.optom_price) {
              item.optom_price = response.data.optom_price;
              item.optom_price = response.data.optom_price;
            }
            if (response.data.chakana_price) {
              item.chakana_price = response.data.chakana_price;
              item.chakana_price = response.data.chakana_price;
            }
            if (response.data.price_type == 2) {
              item.kontragent_price = response.data.delivery_price;
              item.debit_price = response.data.body_price;
            }
          });
          axios({
            method: "get",
            url: "api/v1/product/id/" + item.product_id
          }).then(function (response) {
            item.product = response.data;
            item.pack_norma = response.data.pack_count;
            if (response.data.shtrix_table[0]) {
              item.shtrix_kod = response.data.shtrix_table[0].shtrix_kod;
            }
          });
        }
      },
      Data() {
        let self = this;
        axios
          .get("api/v1/product")
          .then(function (response) {
            self.datas = response.data;
          });
      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Ostatka(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    }
  };
</script>